import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { HubspotContactFormService } from './hubspot-contact-form.service';
export namespace NHubspotContactForm {
    export interface IComponentData extends NICmsContentComponent.IData {
        portalId: string;
        formId: string;
    }
}
@ICmsComponent<PageComponentContactFormComponent>({
    id: 'hubspot-contact-form',
    name: 'Hubspot Contact Form',
    tags: ['form', 'hubspot', 'contact'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'portalId',
            type: NICmsContentField.EFieldType.text,
            title: 'Portal ID',
            required: true
        },
        {
            key: 'formId',
            type: NICmsContentField.EFieldType.text,
            title: 'Form ID',
            required: true
        }
    ]
})
@Component({
    selector: 'page-component-hubspot-contact-form',
    templateUrl: './hubspot-contact-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentContactFormComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: NHubspotContactForm.IComponentData;
    constructor(
        protected elementRef: ElementRef,
        protected renderer2: Renderer2,
        private _hubspotContactFormService: HubspotContactFormService
    ) {
        super();
    }
    override ngOnInit(): void {
        super.ngOnInit();
        if (!this.client.isCms) {
            this._hubspotContactFormService.load({
                elementRef: this.elementRef,
                portalId: this.component.portalId,
                formId: this.component.formId
            });
        }
    }
}
